module.exports = __webpack_public_path__ + "static/media/tick.37b0328e.svg";